<template>
  <v-card color="#EFF3F8" outlined >
    <div class="px-4 card-container text-selection">
      <div v-if="((isUsuarioTradimus && !isStatusCliente) || (!isUsuarioTradimus && isStatusCliente)) &&  canDoActions">
        <v-checkbox
          :input-value="isSelected"
          @change="checkboxChanged"
          @click.stop
        ></v-checkbox>
      </div>
      <div>
        <p class="mb-1">STATUS</p>
        <div class="d-flex direction-row justify-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div class="d-flex-row align-center justify-center" v-on="on">
                <v-icon small class="icon">{{ pagamentoLoteStatusIcon }}</v-icon>
              </div>
            </template>
            <span class="px-2" >{{ pagamentoLoteStatusLabel }}</span>
          </v-tooltip>
          <v-tooltip top v-if="lote.nenhumaGuiaEncontrada && isStatusCliente">
            <template v-slot:activator="{ on }">
              <div class="d-flex-row align-center justify-center pl-3" v-on="on">
                <v-icon small class="icon">fas fa-exclamation</v-icon>
              </div>
            </template>
            <span class="px-2">Nenhuma guia encontrada</span>
          </v-tooltip>
        </div>
      </div>
      <div>
        <p class="mb-1">Nº LOTE </p>
        <p class="font-weight-bold">{{ lote.numeroLote || '-' }}</p>
      </div>
      <div>
        <p class="mb-1">Nº PROTOCOLO </p>
        <p class="font-weight-bold">{{ lote.numeroProtocolo || '-' }}</p>
      </div>
      <div>
        <p class="mb-1">RESPONSÁVEL </p>
        <p class="font-weight-bold">{{ responsavelPagamentoLote }}</p>
      </div>
      <div>
        <p class="mb-1">INFORMADO </p>
        <p class="font-weight-bold text-no-wrap">R$ {{ lote.valorInformado | formatPrice }}</p>
      </div>
      <div>
        <p class="mb-1">PAGO </p>
        <p class="font-weight-bold success--text text-no-wrap">R$ {{ lote.valorPago | formatPrice }}</p>
      </div>
      <div>
        <p class="mb-1">GLOSADO </p>
        <p class="font-weight-bold red--text text-no-wrap">R$ {{lote.valorGlosado | formatPrice }}</p>
      </div>
      <div>
        <p class="mb-1">GUIAS</p>
        <p class="font-weight-bold">{{ lote.quantidadeGuias || 0 }}</p>
      </div>
      <div>
        <p class="font-weight-bold">Itens: {{ lote.quantidadeItens }}</p>
        <p class="font-weight-600 my-1">Recurso: {{ lote.quantidadeItensRecurso }}</p>
        <p class="font-weight-600 my-1">Estorno: {{ lote.quantidadeItensEstorno }}</p>
      </div>
      <div class="conciliacao-lote">
        <p class="status-title font-weight-bold">Conciliação</p>
        <div>
          <PercentBarGroup
            class="align-center"
            :progressBars="[
              {
                label: 'Valor',
                total: lote.status === 'conciliacaoAutomatica' ? 0 : lote.percentualConciliadoValor,
                automatica: lote.percentualConciliadoValorAutomatico,
                manual: lote.percentualConciliadoValorManual,
                textAutomatica: this.valoresConciliacaoTexts.textAutomatica,
                textManual: this.valoresConciliacaoTexts.textManual,
                textRestante: this.valoresConciliacaoTexts.textRestante
              },
              {
                label: 'Itens',
                total: lote.status === 'conciliacaoAutomatica' ? 0 : lote.percentualConciliadoQuantidade,
                automatica: lote.percentualConciliadoQuantidadeAutomatico,
                manual: lote.percentualConciliadoQuantidadeManual,
                textAutomatica: this.itensConciliacaoTexts.textAutomatica,
                textManual: this.itensConciliacaoTexts.textManual,
                textRestante: this.itensConciliacaoTexts.textRestante
              }
            ]"
          />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import PercentBarGroup from '../../common/PercentBarGroup.vue'
import { pagamentoLoteStatusLabels } from '@tradimus/api-conciliacao-client';
import { getItemPercentMessages, getValorPercentMessages } from '../../../libs'

export default {
  data() {
    return {
      pagamentoLoteStatusLabels,
      pagamentoLoteStatusIcons: {
        identificado: 'fa-flag',
        conciliacaoAutomatica: 'fa-robot',
        conciliacaoManual: 'fa fa-user-circle',
        conciliado: 'fa fa-check-double',
        conciliadoParcialmente: 'fa-check',
        naoConciliado: 'fa-minus',

        publicado: 'fa-arrow-alt-circle-up',
        nenhumaGuiaEncontrada: 'fa fa-times-circle'
      }
    };
  },
  props: {
      lote: Object,
      isSelected: Boolean,
      isStatusCliente: Boolean,
      canDoActions: Boolean,
      isUsuarioTradimus: Boolean
  },
  methods: {
    checkboxChanged () {
      this.$emit('change:checkbox')
    }
  },
  components: {
    PercentBarGroup
  },
  computed: {
    valoresConciliacaoTexts () {
      return getValorPercentMessages(
        this.lote.valorInformadoCalculado,
        this.lote.valorItensConciliacaoAutomatica,
        this.lote.valorItensConciliacaoManual
      )
    },
    itensConciliacaoTexts () {
      return getItemPercentMessages(
        this.lote.quantidadeItens,
        this.lote.quantidadeItensConciliacaoAutomatica,
        this.lote.quantidadeItensConciliacaoManual
      )
    },
    pagamentoLoteStatusIcon () {
      if (!this.isStatusCliente && !this.isUsuarioTradimus) {
        return 'fa-clock'
      } else {
        return this.pagamentoLoteStatusIcons[this.lote.status]
      }
    },
    pagamentoLoteStatusLabel () {
      if (!this.isStatusCliente && !this.isUsuarioTradimus) {
        return 'Em processamento Tradimus'
      } else {
        return this.pagamentoLoteStatusLabels[this.lote.status]
      }
    },
    responsavelPagamentoLote () {
      const responsavel = this.lote.responsavel?.nome

      if (!responsavel) {
        return '-'
      }

      if (!this.isStatusCliente && !this.isUsuarioTradimus) {
        return 'Tradimus'
      }

      if (this.isStatusCliente && this.isUsuarioTradimus) {
        return 'Cliente'
      }

      return responsavel
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.text-selection {
  user-select: text;
}
.icon {
  width: 100%;
}
.card-container {
  margin: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.v-tooltip__content {
  background-color: #FFFFFF !important;
  border: 1px solid #CFCFCF !important;
}
.font-weight-600 {
  font-weight: 600;
}
.card {
  align-items: center;
}
.conciliacao-lote {
  width: 15%;
}
</style>
